import React, { PureComponent } from 'react';
import { defineMessages, injectIntl, WrappedComponentProps } from 'react-intl';
import { Modal, ModalProps } from '@lifeomic/chroma-react/components/Modal';
import {
  WithStyles,
  createStyles,
  withStyles,
  Theme,
} from '@lifeomic/chroma-react/styles';

const messages = defineMessages({
  defaultTitle: {
    id: 'fullPageContainer.defaultTitle',
    defaultMessage: 'Survey',
  },
});

const styles = (theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.background.default,
      padding: theme.spacing(2),
      '&:first-child': {
        paddingTop: 0,
      },
    },
    dialog: {
      backgroundColor: theme.palette.background.default,
      padding: 0,
      height: '100%',
      width: '100%',
    },
    header: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
    },
    headerContentContainer: {
      width: '100%',
      maxWidth: theme.breakpoints.values.lg,
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
    },
  });

export interface FullPageContainerOwnProps extends ModalProps {
  onClose: () => void;
  contentClassName?: string;
}

export type FullPageContainerProps = WrappedComponentProps &
  FullPageContainerOwnProps &
  WithStyles<typeof styles>;

class FullPageContainer extends PureComponent<FullPageContainerProps> {
  render() {
    const {
      children,
      isOpen,
      onClose,
      title,
      intl: { formatMessage },
      contentClassName,
    } = this.props;

    return (
      <Modal
        title={title || formatMessage(messages.defaultTitle)}
        isFullScreen={true}
        isOpen={isOpen}
        onDismiss={onClose}
        contentClassName={contentClassName}
      >
        {isOpen ? children : null}
      </Modal>
    );
  }
}

export default injectIntl(withStyles(styles)(FullPageContainer));
